import { render, staticRenderFns } from "./folder-tree.vue?vue&type=template&id=65dba9d1"
import script from "./folder-tree.vue?vue&type=script&lang=js"
export * from "./folder-tree.vue?vue&type=script&lang=js"
import style0 from "./folder-tree.vue?vue&type=style&index=0&id=65dba9d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports